import type { TestTone } from "@mesketch/design-tokens";
import type { DrawingId } from "@mesketch/svg";

// Vazba obsahu na kresby ve fázi 0 (DES-003 §5, §6). Definice metodiky kresby nenese, proto se
// barevná sada testu bere podle slugu a kresba předmětu typu podle pólu. Kompas a maják jsou
// kresby podle mockupu, ostatní póly mají zástupný tvar (zadání 23).

const TONES: Readonly<Record<string, TestTone>> = {
  "who-am-i": "who",
  strengths: "strength",
  emotions: "emotion",
  work: "work",
};

export function toneOf(slug: string): TestTone {
  return TONES[slug] ?? "who";
}

/** Barevná sada testu, nebo null u metodiky bez vlastní sady (nástroj, karta vedlejší sekce). */
export function knownToneOf(slug: string): TestTone | null {
  return TONES[slug] ?? null;
}

const DRAWINGS: Readonly<Record<string, DrawingId>> = { "C+": "compass", "X-": "lighthouse", mosaic: "mosaic" };

/**
 * Kresba je jen zástupná (geometrické tvary): Libor 22. 10. 2026 „vypadá, jako když se dítě učí
 * rýsovat“, takže se nezobrazuje, dokud pól nemá skutečnou kresbu (REQ-023).
 */
export const isPlaceholderDrawing = (id: DrawingId): boolean => id.startsWith("placeholder-");

export function drawingOf(word: string, domains: readonly string[]): DrawingId {
  const known = DRAWINGS[word];
  if (known !== undefined) return known;
  const i = domains.indexOf(word.slice(0, -1));
  return `placeholder-${Math.max(0, i) * 2 + (word.endsWith("+") ? 1 : 0)}`;
}
